import { CommonModule } from '@angular/common';
import { inject, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleXmark } from '@fortawesome/pro-duotone-svg-icons';
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowLeft,
  faCaretDown,
  faCaretUp,
  faColumns,
  faCompress,
  faDownload,
  faExpand,
  faFileArchive,
  faFileExcel,
  faFilePdf,
  faFilePowerpoint,
  faFileWord,
  faMinus,
  faPaperclip,
  faPen,
  faPlus,
  faSearch,
  faStar,
  faTimes,
  faTrashAlt,
} from '@fortawesome/pro-regular-svg-icons';
import { faGripVertical } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { AvatarModule } from '@reconcept-platform/shared/ui/core/avatar';
import { LoadingIndicatorComponent } from '@reconcept-platform/shared/ui/core/loading-indicator';
import { ScrollIntoViewDirective } from '@reconcept-platform/shared/ui/core/scroll-into-view';
import { ButtonComponent } from '@reconcept-platform/shared/ui/standalone/button';
import { InfoBoxComponent } from '@reconcept-platform/shared/ui/standalone/info-box';
import { RcpPopoverDirective } from '@reconcept-platform/shared/ui/standalone/popover';
import { SharedPipesModule } from '@reconcept-platform/shared/util';
import { AutofocusIfDirective } from './autofocus-if.directive';
import { BoxExpandableComponent } from './box-expandable/box-expandable.component';
import { ButtonExpandableOverlayComponent } from './button-expandable-overlay/button-expandable-overlay.component';
import { ChangeDebounceDirective } from './change-debounce/change-debounce.directive';
import { CustomSkillLabelComponent } from './custom-skill-label/custom-skill-label.component';
import { CloseIfOutsideClickDirective } from './directives/close-if-outside-click.directive';
import { DownloadLinkDirective } from './download-link/download-link.directive';
import { ListGroupExpandableModule } from './list-group-expandable/list-group-expandable.module';
import { ListItemNameComponent } from './list-item-name/list-item-name.component';
import { ConfirmationModalComponent } from './modal/confirmation-modal/confirmation-modal.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { SearchResultsComponent } from './search-bar/search-results/search-results.component';
import { SectionExpandableComponent } from './section-expandable/section-expandable.component';
import { PageableTableComponent } from './table/pageable-table/pageable-table.component';
import {
  SortableTableHeaderComponent,
  SortableTableHeaderDirective,
} from './table/sortable-table-header/sortable-table-header.component';
import { TableCheckModule } from './table/table-check/table-check.module';

const uiComponents = [
  ConfirmationModalComponent,
  SearchBarComponent,
  SearchResultsComponent,
  SortableTableHeaderComponent,
  BoxExpandableComponent,
  ListItemNameComponent,
  InfoBoxComponent,
];

const uiDirectives = [SortableTableHeaderDirective, AutofocusIfDirective, DownloadLinkDirective];

const directives = [CloseIfOutsideClickDirective];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LoadingIndicatorComponent,
    RcpPopoverDirective,
    FontAwesomeModule,
    FormsModule,
    SharedPipesModule,
    CustomSkillLabelComponent,
    SectionExpandableComponent,
    ButtonComponent,
    ButtonExpandableOverlayComponent,
    TranslatePipe,
    ScrollIntoViewDirective,
    ChangeDebounceDirective,
    PageableTableComponent,
    ListGroupExpandableModule,
    ...uiComponents,
    ...uiDirectives,
    ...directives,
  ],
  exports: [
    SharedPipesModule,
    RcpPopoverDirective,
    LoadingIndicatorComponent,
    SectionExpandableComponent,
    PageableTableComponent,
    FontAwesomeModule,
    ScrollIntoViewDirective,
    FormsModule,
    ChangeDebounceDirective,
    AvatarModule,
    CustomSkillLabelComponent,
    CommonModule,
    ButtonExpandableOverlayComponent,
    TranslatePipe,
    TableCheckModule,
    ListGroupExpandableModule,
    ...uiComponents,
    ...uiDirectives,
    ...directives,
  ],
})
export class SharedUiWebModule {
  constructor() {
    const library = inject(FaIconLibrary);

    library.addIcons(
      faMinus,
      faExpand,
      faCompress,
      faArrowLeft,
      faAngleLeft,
      faAngleRight,
      faCaretUp,
      faCaretDown,
      faAngleDown,
      faTimes,
      faFileArchive,
      faFilePdf,
      faFileExcel,
      faFileWord,
      faFilePowerpoint,
      faSearch,
      faTrashAlt,
      faPlus,
      faPen,
      faStar,
      faPaperclip,
      faDownload,
      faColumns,
      faCircleXmark,
      faGripVertical,
    );
  }
}
